import { BrowserModule, HammerModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SidebarNavComponent } from './components/sidebar-nav/sidebar-nav.component';
import { HeaderComponent } from './components/header/header.component';
import { MainContentComponent } from './components/main-content/main-content.component';
import { HomeComponent } from './components/main-content/home/home.component';
import { WhyUsComponent } from './components/main-content/why-us/why-us.component';
import { ServicesComponent } from './components/main-content/services/services.component';
import { ClientsComponent } from './components/main-content/clients/clients.component';
import { ContactComponent } from './components/main-content/contact/contact.component';
import { BrainComponent } from './components/main-content/brain/brain.component';
import { LoaderComponent } from './loader/loader.component';

@NgModule({
  declarations: [
    AppComponent,
    SidebarNavComponent,
    HeaderComponent,
    MainContentComponent,
    HomeComponent,
    WhyUsComponent,
    ServicesComponent,
    ClientsComponent,
    ContactComponent,
    BrainComponent,
    LoaderComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HammerModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
